'use client'

import { createClient } from '../../lib/supabase/client'
import IconCircle from '../../components/IconCircle'
import { PillButton } from '../../components/ui'
import { forgetCard } from '../../components/UserChip'
import { forgetRoomCaches } from '../../components/ours/room'
import { forgetAllResumable } from '../../lib/os/resume'
import { endSession } from '../../lib/auth/signOutHere'
import { homepageHref } from '../../lib/nav/siteNav'

const DoorOut = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
)

/** sign out of this browser. `pill`: THE button, with its words (settings → account, where it is the
 *  section's own act); otherwise the round icon. */
export default function SignOutButton({ pill = false }: { pill?: boolean } = {}) {
  const signOut = async () => {
    // the top-right chip caches who is looking for the tab's life — leaving
    // must not leave your face on the front door.
    forgetCard()
    // …and so does the room's page: what it read, the day's offer and its tab notes are the last
    // person's, and the next person to sign in on this tab must not be answered from them.
    forgetRoomCaches()
    // …and every place kept in this browser (an unsent line, a name being typed, where a page was read)
    forgetAllResumable()
    // the server takes the session back (lib/auth/signOutHere); the browser's own client only if it
    // did not answer. Then a real page load, so nothing in memory writes the session back.
    if (!(await endSession())) {
      try { await createClient().auth.signOut({ scope: 'local' }) } catch { /* the page load asks again */ }
    }
    window.location.assign(homepageHref())
  }

  if (pill) {
    return (
      <PillButton type="button" onClick={() => void signOut()} icon={<DoorOut />} style={{ width: 'auto' }}>
        sign out
      </PillButton>
    )
  }
  return (
    <IconCircle onClick={signOut} title="sign out" aria-label="sign out">
      {/* door + arrow out */}
      <DoorOut />
    </IconCircle>
  )
}
